import { render, staticRenderFns } from "./UploadPhotofixrOrders.vue?vue&type=template&id=95334eac&"
import script from "./UploadPhotofixrOrders.vue?vue&type=script&lang=js&"
export * from "./UploadPhotofixrOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports